import React from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { setAllCollections } from '../../../../store/collections/actions';
import { loadMoreSellers } from '../../../../store/sellersView/actions';
import ShowMore from '../../../../../../shared/components/ShowMore';
import Grid from '../../../../../../shared/components/Grid';
import SellerCard from './SellerCard';

import './style.scss';

const Sellers = ({ sellersView, loadMoreSellers }) => (
    <div className="sellers">
        <Grid>
            {sellersView.sellers.map((seller) => (
                <Grid.Item key={seller.id} className="seller-card-item">
                    <SellerCard {...seller} />
                </Grid.Item>
            ))}
        </Grid>
        <ShowMore hasMorePages={sellersView.hasMorePages} loadMore={loadMoreSellers} />
    </div>
);

Sellers.propTypes = {
    sellersView: object,
    loadMoreSellers: func,
};

const mapDispatchToProps = {
    setAllCollections,
    loadMoreSellers,
};

const mapStateToProps = ({ sellersView }) => ({ sellersView });

export { Sellers };
export default connect(mapStateToProps, mapDispatchToProps)(Sellers);
